import React from "react";
import { TitleHeading } from "../typography/TitleHeading";
import BodyText from "../typography/BodyText";
import { HeroCta } from "./HeroCta";
import SideImage from "../layout/SideImage";

interface ImageCtaProps {
  tag: string;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  image: string;
  cta?: React.ReactNode;
  theme?: "dark" | "white" | "gray";
}

const ImageCta: React.FunctionComponent<ImageCtaProps> = ({
  tag,
  title,
  description,
  image,
  cta,
  theme = "dark",
}) => {
  return (
    <SideImage theme={theme} image={image}>
      <div className="mt-6 md:mt-0">
        <TitleHeading theme={theme} tag={tag} title={title} />
        <BodyText dark={theme === "dark"} justify={false} className="mt-2">
          {description}
        </BodyText>
        {cta ?? <HeroCta scheduleCallCta />}
      </div>
    </SideImage>
  );
};

export default ImageCta;
